export default {
  name: 'Jobs',
  title: 'Section Title',
  companyName: 'Company / BU',
  jobName: 'Jobs',
  pleaseSelect: 'Please Select',
  jobSearchKeywordPlaceholder: 'Please input job name',
  jobSearchBtn: 'Search',
  noData: 'No Result',
  noMatchedData: 'No Matches',
  selectAll: 'All',
  releaseDate: 'Release Date: ',
  roleType: 'Role Type',
  workExp: 'Work Experience',
  workTime: 'Work Time',
  workExpNotLimited: 'Not Specified',
  workExpYear: 'Year',
  showMoreJobs: 'View More Jobs',
  location: {
    prefix: '',
    suffix: 'addresses'
  }
}
